import React from "react";
import { useTranslation } from "react-i18next";

import { Action } from "../../../../components/subsidiary_mode_alert";
import { useBulkUpdateContext } from "../../../components/bulk_update_modal/bulk_update_context_provider";
import { EditMode } from "../../../types/edit_mode";
import { useBookingModuleContext } from "../../providers/booking_module_context_provider";
import { useBookingRowsContext } from "../context/booking_rows_context";
import { InfoOverlay } from "./info_overlay";

type SplitModeWarningOverlayProps = {
  headerRef: React.MutableRefObject<HTMLDivElement>;
};

export const SelectModeWarningOverlay = ({ headerRef }: SplitModeWarningOverlayProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "selectMode.warningOverlay" });
  const {
    setEditMode,
    selectEditMode: { selection, bookingsCount }
  } = useBookingRowsContext();
  const {
    modal: { open }
  } = useBulkUpdateContext();

  const { setHeaderDisabled } = useBookingModuleContext();

  const handleClose = () => {
    setEditMode(EditMode.Disabled);
    setHeaderDisabled(false);
  };

  const handleOpenBulkSelect = () => {
    open(selection);
  };

  const selectedItemsCount = bookingsCount ?? 0;

  const actions: Action[] =
    selectedItemsCount > 0
      ? [
          {
            icon: "edit",
            onClick: handleOpenBulkSelect
          }
        ]
      : [];

  const message = selectedItemsCount > 0 ? t("itemsSelected", { count: selectedItemsCount }) : t("empty");

  return (
    <InfoOverlay
      headerRef={headerRef}
      message={bookingsCount !== undefined ? message : ""}
      onClose={handleClose}
      actions={actions}
    />
  );
};
